export default "__VITE_ASSET__P$sas5se__"